import { Component, HostListener, ChangeDetectionStrategy } from '@angular/core';
import { RouterOutlet } from '@angular/router';

@Component({
    selector: 'app-root',
    imports: [
        RouterOutlet,
    ],
    templateUrl: './app.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrl: './app.component.scss'
})
export class AppComponent {
    title = $localize`octoplus-landing-page`;

    @HostListener('window:scroll')
    onWindowScroll() {
        this.scrollFunction();
    }

    ngOnInit() {
        if (typeof window !== 'undefined') {
            this.handleScroll();
            window.addEventListener('scroll', () => {
                this.handleScroll();
            });
        }
    }

    handleScroll() {
        const sections = document.querySelectorAll('section');

        sections.forEach(section => {
            const animatedElements = section.querySelectorAll('.animate');

            if (this.isElementInViewport(section)) {
                animatedElements.forEach(element => {
                    element.classList.add('animated');
                });
            }
        });
    }

    isElementInViewport(el: Element) {
        const rect = el.getBoundingClientRect();
        return (
            rect.bottom >= 0 &&
            rect.right >= 0 &&
            rect.top <= (window.innerHeight || document.documentElement.clientHeight) &&
            rect.left <= (window.innerWidth || document.documentElement.clientWidth)
        );
    }

    scrollFunction() {
        const scrollToTopBtn = document.getElementById("scrollToTop");
        const mainNav = document.getElementById("mainNav");

        if (mainNav) { // Vérifie si mainNav est défini
            if (document.body.scrollTop > 75 || document.documentElement.scrollTop > 75) {
                mainNav.classList.add("animate");
                mainNav.classList.add("fixed-top");
                document.body.style.marginTop = "75px";

                if (scrollToTopBtn) {
                    scrollToTopBtn.style.opacity = "1";
                }
            } else {
                mainNav.classList.remove("animate");
                mainNav.classList.remove("fixed-top");
                document.body.style.marginTop = "0";
                if (scrollToTopBtn) {
                    scrollToTopBtn.style.opacity = "0";
                }
            }
        }

        // Ajoutez un écouteur d'événements pour cliquer sur le bouton scrollToTopBtn
        if (scrollToTopBtn) {
            scrollToTopBtn.addEventListener("click", () => {
                this.scrollToTop(); // Appel de la fonction scrollToTop() lorsque le bouton est cliqué
            });
        }
    }

    scrollToTop() {
        window.scrollTo({
            top: 0,
            behavior: "smooth"
        });
    }
}
